module.exports = __webpack_public_path__ + "assets/img/logo-tablet.89454d49.png";